import axios from "axios";
import sanity from "../client";

export async function getAvailableServiceSlugs() {
  const euroPetrolBody = JSON.stringify({
    url: "https://app.lion-group.rs/epk/v2",
    action: "updateBS",
    data: {},
  });

  const response = await axios("https://app.lion-group.rs/epk/v2", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
    },
    data: euroPetrolBody,
  });

  const data = await response.data;

  const responseData = data.data;

  return responseData.services
    .filter((service) => service.category === 1)
    .map((service) => {
      return {
        serviceID: service.product.toString(),
        lastmod: "December 19, 2025",
        priority: 0.5,
      };
    });
}

export async function getSanitySlugs(filters, priority, changefreq = "never") {
  const query = `${filters}{
    _id, slug, _updatedAt,
  }`;

  const posts = await sanity.fetch(query);

  return posts.map((post) => {
    return {
      slug: post.slug.current,
      lastmod: post._updatedAt,
      priority,
      changefreq,
    };
  });
}
